import * as Emotion from 'emotion';

// eslint-disable-next-line import/prefer-default-export
export const chartContainerWithHeight = (height) => Emotion.css`
  width: 100%;
  height: ${height}px;
`;
